const EngagementTypes = Object.freeze({
    CONTRACT: "Contract",
    DIRECT_HIRE: "Direct Hire",
    FRACTIONAL: "Fractional",
});

export default EngagementTypes;
